import requestCommon from "@/components/web-interface/requestCommon";
const state = {
  techData: null,
};
const actions = {
  getTechData(context, data) {
    let payload = {
      type: data.type,
      app: "Itrade"
    }
    return requestCommon.getInfo(
      "/apps/" + payload.app + "/" + payload.type,
      null,
      null,
      context,
      "getTechDataSuccessHandler",
      "getTechDataErrorHandler"
    );
  },
}
const mutations = {
  getTechDataSuccessHandler(state, data) {
    state.techData = data.server.data;
  },
  getTechDataErrorHandler(context, error,) {
    console.log(error);
  },
};
const getters = {};
export const techDashboardStore = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}